import { FC, MouseEvent, useCallback, useMemo, useState } from 'react';

import Backdrop from '../../../components/Backdrop/Backdrop';
import Button from '../../../components/Button';
import { CloseButton } from '../../../components/CloseButton/CloseButton';
import DateTime from '../../../helpers/DateTime';
import { Appointment } from '../../../interfaces/Appointment';
import { Urls } from '../../../interfaces/Calendar';
import { sendCalendarOpened, sendCalendarSelected } from '../../../services/Analytics';
import getUrls from '../../../services/CalendarService';
import styles from './Calendar.module.scss';

interface CalendarProps {
  appointment: Appointment;
  partnerName: string;
  text: string;
}

const CalendarComponent: FC<CalendarProps> = ({ text, appointment, partnerName }) => {
  const [isOpen, setIsOpen] = useState(false);

  const onClick = useCallback((event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    setIsOpen((previousValue) => !previousValue);
    sendCalendarOpened();
  }, []);

  const urls: Urls = useMemo(() => {
    const startTime = DateTime.roundToNearestMinutes(appointment.arrivalWindowStart || DateTime.today());
    const endTime = DateTime.roundToNearestMinutes(appointment.arrivalWindowEnd || DateTime.today());

    return getUrls({
      start: startTime.toISOString(),
      finish: endTime.toISOString(),
      title: partnerName + ' monteur komt langs',
      address: 'Thuis',
      description: ''
    });
  }, [appointment, partnerName]);

  const dropDownContent = useMemo<{ label: string; url: keyof Urls }[]>(() => [
    { url: 'google', label: 'Google' },
    { url: 'yahoo', label: 'Yahoo' },
    { url: 'ics', label: 'Ical' },
    { url: 'outlook', label: 'Outlook' },
  ], []);

  const onClose = useCallback(() => setIsOpen(false), []);

  return (
    <div className={styles.calendarConfirm}>
      <Backdrop onClick={onClose} visible={isOpen} />
      <Button onClick={onClick} size="small" text={text} />
      {isOpen && (
        <ul className={styles.dropdownContent} id="calendar">
          <CloseButton alignment="topRight" onClick={onClose} />
          {!!dropDownContent.length && dropDownContent.map(({ url, label }) => (
            <li aria-label={label} key={label}>
              <Button onClick={() => {
                sendCalendarSelected(url);
                window.open(urls[url], '_blank', 'noopener,noreferrer');
              }} size="small" text={label}/>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default CalendarComponent;
